import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
import logo2 from '../../assets/logo.avif'
import { Button, message, Modal, Popover, Row } from "antd";
import "../../Pages/Dashboard/Dashboard.css";
import {
  LogoutOutlined,
  MenuOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import HrNavbar from "../Navbars/HrNavbar.js";
import DarNavbar from "../Navbars/DarNavbar.js";
import IsrNavbar from "../Navbars/IsrNavbar.js";
import { Link, useNavigate } from "react-router-dom";
import OpuNavbar from "./OpuNavbar.jsx";
import DirectorNavbar from "../Navbars/DirectorNavbar.jsx";
import styles from "./AppHeader.module.css";
import HeaderSidebar from "./HeaderSidebar.jsx";
import OtherUserNavbar from "../Navbars/OtherUserNavbar.jsx";
import AdminNavbar from "../Navbars/AdminNavbar.jsx";
import { deleteCookie } from "../../Pages/ReviewPortal/ReviewPortal.helpers.js";

export default function AppHeader(props) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData.userRole;
  const isSalesNetUser = userData.isSalesNetUser;
  const [OldPassword, setOldPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [loginErrorMssg, SetLoginErrorMssg] = useState("");
  const [resCOlor, SetresCOlor] = useState("");
  const [open, setOpen] = useState(false);
  const base64Image = `data:image/png;base64, ${localStorage.getItem(
    "userImage"
  )}`;
  const [showChangePwdModal, setShowChangePwdModal] = useState(false);

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const navigate = useNavigate();

  const Reset = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    SetLoginErrorMssg("");
  };

  async function ChangePassword() {
    let formData = {
      OldPassword: OldPassword,
      NewPassword: NewPassword,
      ReEnterPassword: ConfirmPassword,
    };
    const res = await fetch(
      `${localStorage.getItem("BaseUrl")}/Authentication/changepassword`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );
    const Response = await res.json();
    if (Response.resCode === 200) {
      SetLoginErrorMssg("Password Change Successfull!");
      SetresCOlor("text-success");
      return true;
    } else if (Response.resCode === 400) {
      SetLoginErrorMssg(Response.resData);
      SetresCOlor("text-danger");
      return false;
    }
  }

  const onClose = () => {
    setOpen(false);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  return (
    <div>
      <HeaderSidebar onClose={onClose} open={open} />
      <nav className={`navbar ${styles.cssHead} navbar-fixed-top`}>
        <div className={styles.headlogo1}>
          <img src={logo2} className={`img-fluid ${styles.logo}`} />
        </div>

        <Button
          style={{ marginRight: "20px" }}
          onClick={showDrawer}
          className={styles.menuBtn}
        >
          <MenuOutlined />
        </Button>

        <div className={styles.topSearchBar} style={{ marginBottom: "-16px" }}>
          <ul className={`${styles.mobNav} ${styles.serviceBtns}`}>
            <li>
              <Link
                to="/Dashboard"
                style={{ textDecoration: "none", fontSize: "12px" }}
              >
                Dashboard
              </Link>
            </li>
            <li>
              <Link
                to="/HumanResource"
                style={{ textDecoration: "none", fontSize: "12px" }}
              >
                Human Resource
              </Link>
            </li>
            <li>
              <Link
                to="/Attendance"
                style={{ textDecoration: "none", fontSize: "12px" }}
              >
                Attendance
              </Link>
            </li>
            <li>
              <Link
                to="/KnowledgeShare"
                style={{ textDecoration: "none", fontSize: "12px" }}
              >
                Knowledge Sharing
              </Link>
            </li>
            <li>
              <Link
                to="/HolidayList"
                style={{ textDecoration: "none", fontSize: "12px" }}
              >
                Holiday List
              </Link>
            </li>
          </ul>
        </div>
        <div className="d-flex align-items-end mr-lg-5">
          <Popover
            placement="bottomRight"
            trigger="hover"
            overlayClassName={styles.profilePopover}
            content={
              <div className={styles.profileCard}>
                {/* Header */}
                <div className={styles.profileHeader}>
                  <img
                    src={base64Image}
                    className={styles.profileAvatar}
                    alt="Profile"
                  />
                  <div className={styles.profileInfo}>
                    <h6>{props.data.userName}</h6>
                    <p>{props.data.email}</p>
                  </div>
                </div>

                {/* Actions */}
                <div className={styles.profileActions}>
                  <button
                    className={styles.profileItem}
                    onClick={() => setShowChangePwdModal(true)}
                  >
                    <SettingOutlined />
                    <span>Change Password</span>
                  </button>

                  <button
                    className={`${styles.profileItem} ${styles.logout}`}
                    onClick={() => {
                      deleteCookie('rp'); // only for HR users
                      navigate("/", { replace: true });

                      const keys = [
                        "EmpId",
                        "userData",
                        "JwtToken",
                        "userImage",
                        "probationInfo",
                      ];

                      keys.forEach((key) => localStorage.removeItem(key));

                      localStorage.clear();
                      localStorage.setItem(
                        "BaseUrl",
                        process.env.REACT_APP_BASE_URL
                      );
                    }}
                  >
                    <LogoutOutlined />
                    <span>Sign Out</span>
                  </button>
                </div>
              </div>
            }
          >
            <Button
              shape="circle"
              size="large"
              style={{ border: "none", padding: 0 }}
            >
              <img 
              src={base64Image} 
              className={styles.defaultpfp3}
              style={{ borderRadius: "50%", marginTop: "3%", border: "3px" }} 
              alt="Pic" />
            </Button>
          </Popover>

          {/* <Popover
            placement="bottomRight"
            content={
              <div className={styles.profileMenu} style={{ margin: "-12px" }}>
                <div className={`${styles.profileOption} p-3`}>
                  <div className="mt-2 row">
                    <div className="col-3 d-flex justify-content-center align-items-center">
                      <img
                        src={base64Image}
                        style={{ borderRadius: "50%", width: '45px' }}
                        className={styles.defaultpfp3}
                        alt="Profile"
                      />
                    </div>
                    <div className={`${styles.userDataa} col-8 p-0`}>
                      <h6>{props.data.userName}</h6>
                      <p>{props.data.email}</p>
                    </div>
                  </div>
                </div>
                <a
                  role="button"
                  className={`${styles.profileListData} pt-3 btn popovers`}
                  style={{ borderBottom: "1px solid" }}
                  // data-toggle="modal"
                  // data-placement="top"
                  // data-target=".bd-example1-modal-lg"
                  onClick={() => setShowChangePwdModal(true)}
                >
                  <div className={styles.profileListIcon}>
                    <SettingOutlined
                      style={{ fontSize: "25px", paddingRight: "20px" }}
                    />
                  </div>
                  <div className={styles.notificationListBodyText}>
                    <h6>Change Password</h6>
                  </div>
                </a>
                <button
                  className={styles.profileListData}
                  style={{
                    color: "black",
                    textDecoration: "none",
                    border: "none",
                    background: "transparent",
                  }}
                  onClick={(e) => {
                    navigate("/", { replace: true });
                    const empId = localStorage.getItem("EmpId");
                    const userData = localStorage.getItem("userData");
                    const jwtToken = localStorage.getItem("JwtToken");
                    const userImg = localStorage.getItem("userImage");
                    const probationInfo = localStorage.getItem("probationInfo");

                    if (empId) {
                      localStorage.removeItem("EmpId");
                    }

                    if (userData) {
                      localStorage.removeItem("userData");
                    }

                    if (jwtToken) {
                      localStorage.removeItem("JwtToken");
                    }

                    if (userImg) {
                      localStorage.removeItem("userImage");
                    }

                    if(probationInfo) {
                      localStorage.removeItem("probationInfo")
                    }

                    localStorage.clear();
                    localStorage.setItem("BaseUrl", process.env.REACT_APP_BASE_URL);
                  }}
                >
                  <div className={styles.profileListIcon}>
                    <LogoutOutlined
                      style={{ fontSize: "25px", paddingRight: "20px" }}
                    />
                  </div>
                  <div className={styles.notificationListBodyText}>
                    <h6>Sign-out</h6>
                  </div>
                </button>
              </div>
            }
          >
            <Button shape="circle" size="large">
              <img
                src={base64Image}
                className={styles.defaultpfp3}
                style={{ borderRadius: "50%" }}
                alt="Pic"
              />
            </Button>
          </Popover> */}
        </div>
      </nav>
      <nav
        className={`shadow p-2 px-4 navbar-inverse navbar-fixed-top ${styles.navDropdown}`}
        style={{ backgroundColor: "#f3f5f9" }}
      >
        {`${userRole}` === "Manager" ||
        `${userRole}` === "User" ||
        `${userRole}` === "Sales" ? (
          // `${userRole}` === "Power"
          <DarNavbar />
        ) : null}
        {`${userRole}` === "Hr" ? <HrNavbar /> : null}
        {`${userRole}` === "ISR" || `${userRole}` === "Head ISR" ? (
          <IsrNavbar />
        ) : null}
        {`${userRole}` === "OPU" ? <OpuNavbar /> : null}
        {`${userRole}` === "Director" ? <DirectorNavbar /> : null}
        {`${userRole}` === "" ||
        `${userRole}` === "Power" || // this user is for
        `${userRole}` === "Network" ? (
          <OtherUserNavbar />
        ) : null}
        {`${userRole}` === "Administrator" ? <AdminNavbar /> : null}
      </nav>
      <Modal
        open={showChangePwdModal}
        onCancel={() => setShowChangePwdModal(false)}
        footer={[
          <Row className="d-flex justify-content-end">
            <Button
              type="default"
              onClick={() => {
                if (
                  ConfirmPassword.length > 0 ||
                  OldPassword.length > 0 ||
                  NewPassword.length > 0
                ) {
                  Reset();
                } else {
                  setShowChangePwdModal(false);
                }
              }}
            >
              Reset
            </Button>

            <Button
              type="primary"
              onClick={async () => {
                const result = await ChangePassword();
                if (result) {
                  message.success("Password changed successfully");
                } else {
                  message.error("Could not change passwords");
                }
                setConfirmPassword("");
                setNewPassword("");
                setOldPassword("");
                setShowChangePwdModal();
              }}
              className="ml-2"
            >
              Change Password
            </Button>
          </Row>,
        ]}
      >
        <form>
          <div className="form-group row">
            <label className="col-lg-3 col-form-label">Old Password</label>
            <div className="col-lg-9">
              <input
                type="text"
                value={OldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Old Password"
                className="form-control"
                required
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-lg-3 col-form-label">New Password</label>

            <div className="col-lg-9">
              <input
                type="password"
                placeholder="New Password"
                value={NewPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="form-control"
                required
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-lg-3 col-form-label">Confirm Password</label>

            <div className="col-lg-9">
              <input
                type="password"
                placeholder="Confirm Password"
                value={ConfirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-control"
                required
              />
            </div>
          </div>
          {loginErrorMssg ? (
            <div>
              <p className={`${resCOlor}`}>{loginErrorMssg}</p>
            </div>
          ) : null}
        </form>
      </Modal>
    </div>
  );
}
